import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Button, Grid, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FeAutocomplete } from "../../../FormElements";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { updateObjectValue } from "../../../../utils/helper";

import dayjs from "dayjs";
import { isEmpty } from "lodash";
import adminAPi from "../../../../utils/adminAPi";
import FeDesktopDatePicker from "../../../FormElements/FeDesktopDatePicker";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const surgeryModalityOptions = [
  "Lumpectomy with ALND",
  "Lumpectomy with SnLNBx",
  "Mastectomy with ALND",
  "Mastectomy with SnLNBx",
  "Unplanned Limpectomy",
];
const SurgeryChemoDetails = ({ onStateChange, editedObj, updatedObj }) => {
  const [obj, setObj] = useState({
    surgeries: [
      {
        surgery_date: "2023-01-01",
        modality: "",
      },
    ],
  });

  const [modList, setModList] = useState([]);
  const [hisValue, setHisValue] = useState([]);
  const [clinicalList, setClinicalList] = useState([]);
  const [clinicalValue, setClinicalValue] = useState([]);

  useEffect(() => {
    getModList();
    // getStagingClinical();
    return () => {};
  }, []);
  useEffect(() => {
    if (editedObj) {
      setObj(Object.assign({}, obj, editedObj));
    }
  }, [editedObj]);
  useEffect(() => {
    if (updatedObj) {
      const u = updateObjectValue(obj, updatedObj);
      setTimeout(() => {
        setObj(u);
      }, 100);
    }
  }, [updatedObj]);
  const getModList = async () => {
    const { data } = await adminAPi.get("admin/surgery-modality-records-all");
    console.log("DATA SURGERY", data.data);
    setModList(data.data);
  };
  const getStagingClinical = async () => {
    const { data } = await adminAPi.get("admin/staging-clinical-records-all");
    console.log("DDDD", data);
    setClinicalList(data.data);
  };

  const handleChangeInput = (name, value) => {
    setObj({ ...obj, [name]: value });
  };
  const addDiagnosisField = () => {
    setObj({
      ...obj,
      surgeries: [
        ...obj.surgeries,
        {
          surgery_date: "2023-01-01",
          modality: "",
        },
      ],
    });
  };
  const removeDiagnosisFields = (index) => {
    const rows = [...obj.surgeries];
    rows.splice(index, 1);
    setObj({ ...obj, surgeries: rows });
  };
  const handleChangeDiagnosis = (index, name, value) => {
    const list = [...obj.surgeries];
    list[index][name] = value;
    setObj({ ...obj, surgeries: list });
  };
  useEffect(() => {
    if (!isEmpty(obj)) onStateChange(obj);
  }, [obj]);
  return (
    <>
      {" "}
      <Grid item xs={8} sm={8}>
        <Grid item xs={12} sm={12}>
          <Grid container spacing={1}>
            <Grid mb={1} item sm={4}>
              Surgery
            </Grid>
          </Grid>
          {obj.surgeries.map((data, index) => {
            const { surgery_date, modality } = data;

            return (
              <Grid container spacing={2} key={index}>
                <Grid item xs={6} md={4} mb={1}>
                  <FeDesktopDatePicker
                    label="Surgery Date"
                    inputFormat="DD/MM/YYYY"
                    name="surgery_date"
                    value={surgery_date}
                    //  disabled={editedObj}
                    onChange={(val) => {
                      handleChangeDiagnosis(
                        index,
                        "surgery_date",
                        dayjs(val).format("YYYY-MM-DD")
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={4} mb={1}>
                  {/* <FeAutocomplete
                    options={modList}
                    id="Modality"
                    label="Modality"
                    onChange={(event, v) => {
                      handleChangeDiagnosis(index, "modality", v.name);
                    }}
                    getOptionLabel={(option) => {
                      return editedObj ? option.detail : option.name;
                    }}
                  /> */}
                  <FeAutocomplete
                    options={modList.map((o) => o.name)}
                    id="Modality"
                    label="Modality"
                    value={modality}
                    //  disabled={editedObj}
                    onChange={(e, v) => {
                      handleChangeDiagnosis(index, "modality", v);
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  {obj.surgeries.length !== 1 && (
                    <IconButton
                      aria-label="delete"
                      size="large"
                      color="error"
                      //  disabled={editedObj}
                      onClick={() => removeDiagnosisFields(index)}
                    >
                      <DeleteForeverIcon fontSize="inherit" />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            );
          })}
          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="success"
              //  disabled={editedObj}
              onClick={addDiagnosisField}
            >
              Add New
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default SurgeryChemoDetails;
